/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Cancel01Icon } from '@hugeicons/core-free-icons/index';

export interface CalendarIntegrationPromptData {
  message: string;
  integrationType: 'outlook' | 'google';
}

@Component({
  selector: 'ptl-calendar-integration-prompt',
  templateUrl: './calendar-integration-prompt.component.html',
  styleUrls: ['./calendar-integration-prompt.component.scss'],
})
export class CalendarIntegrationPromptComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: CalendarIntegrationPromptData,
    private snackBarRef: MatSnackBarRef<CalendarIntegrationPromptComponent>,
    private router: Router,
  ) {}

  onGoToSettings(): void {
    this.snackBarRef.dismiss();
    this.router.navigate(['/account', 'settings']);
  }

  onDismiss(): void {
    this.snackBarRef.dismiss();
  }

  protected readonly Cancel01Icon = Cancel01Icon;
}
